import { render } from "./SignContract.vue?vue&type=template&id=1874014f&scoped=true"
import script from "./SignContract.vue?vue&type=script&lang=js"
export * from "./SignContract.vue?vue&type=script&lang=js"

import "./SignContract.vue?vue&type=style&index=0&id=1874014f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1874014f"]])

export default __exports__